import React from 'react';
import * as microsoftTeams from '@microsoft/teams-js';
import Iframe from '../iframe/iframe';

class MarcacionDocente extends React.Component {
  state = {
    context: {},
    styles: {
      display: 'block',
      width: '100vw',
      height: '100vh',
    },
    title: 'marcacion-docente',
    src: '',
  };

  componentDidMount() {
    microsoftTeams.getContext((context, error) => {
      this.setState(
        {
          context: context,
        },
        () => {
          const { context } = this.state;
          const userName =
            Object.keys(context).length > 0 ? context['upn'] : '';
          const indice = userName.indexOf('@');
          const cu = userName.substring(0, indice);
          this.setState({
            src: `https://servicios.ufg.edu.sv/marcacionteams/index.php?cu=${cu}&userObjectId=${context['userObjectId']}`,
          });
        }
      );
    });
  }

  render() {
    const { styles, title, src } = this.state;

    return (
      <div>
        <Iframe mystyle={styles} url={src} title={title} />
      </div>
    );
  }
}
export default MarcacionDocente;
